import { Grid, Button, Modal, useTheme } from '@mui/material';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { sxStyled } from './styles';

const SendedItineraryModal = ({
  sendedItineraryModal,
  setSendedItineraryModal,
  BlackTypography,
  modalStyle,
  setCloseSeeShareItineraryModal,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const setCloseSendedItineraryModal = () => {
    setSendedItineraryModal(false);
    setCloseSeeShareItineraryModal();
  };

  return (
    <Modal open={sendedItineraryModal} onClose={setCloseSendedItineraryModal}>
      <Grid
        container
        direction="column"
        style={{ ...modalStyle, alignItems: 'center' }}
        sx={sxStyle.itinerarySeeModalGrid}
        spacing={2}
      >
        <Grid item>
          <CheckCircleIcon
            style={{
              color: '#03C868',
              fontSize: 100,
              alignSelf: 'center',
            }}
          />
        </Grid>
        <Grid item>
          <BlackTypography style={{ alignSelf: 'center', fontWeight: 600 }}>
            Itinerario
          </BlackTypography>
        </Grid>
        <Grid item>
          <BlackTypography style={{ alignSelf: 'center' }}>
            El itinerario fue enviado al email indicado.
          </BlackTypography>
        </Grid>
        <Grid item style={{ minWidth: '302px' }}>
          <Button
            id="itinerary-close-modal"
            variant="text"
            sx={sxStyle.closeSeeShareItineraryModalBotton}
            onClick={() => setCloseSendedItineraryModal()}
            style={{ alignSelf: 'center', width: '100%' }}
          >
            Cerrar
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default SendedItineraryModal;
